import { ResourceCardLayout } from "../../../ui/Learning/ResourceCardLayout";
import { ResourceCard } from "../../../ui/Learning/ResourceCard";
import { isDisabled } from "../utils/util";

export function ChapterList({ chapters, loading, onClick }) {
  return (
    <ResourceCardLayout
      total={chapters.length}
      message="0 chapters to display"
      loading={loading}
    >
      {chapters
        .sort((a, b) => a.priority - b.priority)
        .map((val) => (
          <ResourceCard
            key={val._id}
            name={val.name}
            thumbnail={val.thumbnail}
            isDisabled={val.disabled || isDisabled(val.topics)}
            onClick={() => onClick(val)}
          />
        ))}
    </ResourceCardLayout>
  );
}
